import React from 'react';
import { useLocation } from 'react-router-dom';
import { LOOK_NAMES, otherLook, switchHref } from './look';
import useLook from './useLook';

// The way back (or forward) at the foot of every page, in both looks
const LookFooter = () => {
  const look = useLook();
  const { pathname } = useLocation();
  const other = otherLook(look);

  return (
    <p className="asaj-look-foot">
      You are viewing the {LOOK_NAMES[look]}.{' '}
      <a href={switchHref(pathname, other)} rel="nofollow">
        Switch to the {LOOK_NAMES[other]}
      </a>
    </p>
  );
};

export default LookFooter;
